import React, { useContext, useEffect, useRef } from 'react'
import { CantiqueContextAPI } from '../Context/CantiqueContext';
import Highlight from '../components/Highlight';

const CantiquesDetails = () => {
  const { selectedCantique, loading, searchTerm } = useContext(CantiqueContextAPI);
  const containerRef = useRef(null);

  // bring the first highlighted lyric into view when opening a cantique from a search
  useEffect(() => {
    if (loading || !selectedCantique || !searchTerm) return;
    const firstMatch = containerRef.current?.querySelector('.search-highlight');
    if (firstMatch) firstMatch.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCantique?.id, loading]);

  // display a simple spinner during the small loading delay
  if (loading) {
    return (
      <div className="cantiquesDetails">
        <div className="cantiquesDetails__container">
          <div className="loading-spinner" />
        </div>
      </div>
    );
  }

  if (!selectedCantique) {
    return (
      <div className="cantiquesDetails">
        <div className="cantiquesDetails__container">
          <p>Sélectionnez un cantique</p>
        </div>
      </div>
    );
  }

  return (
    <div className="cantiquesDetails">
        <div className="cantiquesDetails__container" ref={containerRef}>
          {selectedCantique.couplets.map((couplet, index) => (
            <React.Fragment key={index}>
              <div className="cantiquesDetails__couplet">
                <div className="cantiquesDetails__couplet__number">{(couplet.numero ?? couplet.number)}.</div>
                <div className="cantiquesDetails__couplet__text">
                  <span><Highlight text={couplet.text} query={searchTerm} /></span>
                </div>
              </div>

              {/* Afficher refrain après le premier couplet s'il existe */}
              {index === 0 && selectedCantique.refrain && (
                <div className="cantiquesDetails__choeur__refrain">
                  <span>Refrain:</span>
                  <div className="cantiquesDetails__choeur__text">
                    <Highlight text={selectedCantique.refrain.text} query={searchTerm} />
                  </div>
                </div>
              )}

              {/* Afficher semi-choeur après le premier couplet s'il existe */}
              {index === 0 && selectedCantique.semiChoeur && (
                <div className="cantiquesDetails__choeur">
                  <span>*</span>
                  <div className="cantiquesDetails__choeur__text">
                    <Highlight text={selectedCantique.semiChoeur.text} query={searchTerm} />
                  </div>
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
    </div>
  )
}

export default CantiquesDetails
